<app-panel-header-image-view pretitle="{{'members.members' | transloco}}" title="{{'members.archery_federations' | transloco}}" banner_image="../../../../../modules/custom/wa_angular/app/assets/images/test-image-members.jpg"></app-panel-header-image-view>

<app-app-content-page-wrapper>
  <div class="members__header">
    <div class="intro">
      <div class="intro__text">
        <img src="../../../../../modules/custom/wa_angular/app/assets/images/world_archery.png" title="World Archery" alt="World Archery">
        <div>
          <p class="intro__text__content">{{'members.intro' | transloco}}</p>
          <p class="intro__text__content">{{'members.intro_2' | transloco}}</p>
        </div>
      </div>
      <div class="intro__counter">
        <app-number-background [number]="count"></app-number-background>
        <div>{{'members.national_federations' | transloco}}</div>
      </div>
    </div>
  </div>
<div class="countries">
  <h2>{{'members.continental_federations' | transloco}}</h2>
  <div>
      <app-table-members-search-item [isActive]="(filter_service.regionCombo.comboData|async).CaId===continent.CaId" (click)="selectContinent(continent, true)" *ngFor="let continent of continentNames|async" [continent]="continent.Continent" [image]="getContinentAsset(continent.Continent)|async">
      </app-table-members-search-item>
  </div>
  <div *ngIf="(filter_service.regionCombo.comboData|async) as continent">
    <app-continental-federation-link *ngIf="continent.CaId"  [memberId]="(continent).CaId"></app-continental-federation-link>
  </div>
</div>
  <app-members-filters-component></app-members-filters-component>
  <app-table-members-search></app-table-members-search>
  <app-news-panel *ngIf="news && news.length > 0" [news]="news" [title]="'related_news' | transloco" ></app-news-panel>
</app-app-content-page-wrapper>
